import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromOrgSupplementalSystem from '@store/reducers/org-supplemental-system/org-supplemental-system.reducer';

export const selectOrgSupplementalSystemState =
  createFeatureSelector<fromOrgSupplementalSystem.State>(
    fromOrgSupplementalSystem.orgSupplementalSystemFeatureKey
  );

export const selectSupplementalSystems = createSelector(
  selectOrgSupplementalSystemState,
  (state) =>
    [...state.systems].sort((a, b) => {
      const aRank = a.statusID === 1000 ? 0 : 1;
      const bRank = b.statusID === 1000 ? 0 : 1;
      return aRank - bRank;
    })
);

export const selectSupplementalSystemOrgId = createSelector(
  selectOrgSupplementalSystemState,
  (state) => state.organizationId
);

export const selectIsSupplementalSystemSaveDisabled = createSelector(
  selectOrgSupplementalSystemState,
  (state) => state.isSaveDisabled
);
